import React from 'react';
import {Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import {compose} from 'redux'
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import MenuLeft from '../User/Dashboard/DashComponents/MenuLeft/MenuLeft'
import MainDashContent from '../User/Dashboard/DashContent/MainDashContent'
import AllClients from '../User/Dashboard/DashContent/AllClients'
import Test from '../User/Dashboard/DashContent/Test'
import UserProfile from '../User/Dashboard/DashContent/UserProfile';
import Scheduler from '../User/Dashboard/DashContent/Scheduler'
import Trainers from '../User/Dashboard/DashContent/Traniers';
import Avatar from '@material-ui/core/Avatar';
import Workout from '../User//Dashboard/DashContent/Workout';
import Nutrition from '../User/Dashboard/DashContent/Nutrition';
import Notifications from '../User/Dashboard/GlobalComponents/Notifications/Notification'
import fbConfig from '../../config/firebaseConfig'
import TrainerProfilePage from '../User/Dashboard/DashComponents/TrainerProfilePage/TrainerProfilePage'
import MenuTop from '../User/Dashboard/DashComponents/MenuTop/MenuTop'
const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
     background: '#ffffff',

    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 24,
    background: 'white',
    transition: 'all 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  menuButtonHidden: {
    display: 'none',
  },
  menuLogo: {
    marginLeft: 12,
    marginRight: 36,
    opacity: 1,
    background: "#fff",
  },
  menuLogoHidden: {
    opacity: 0,
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '100vh',
    overflow: 'auto',
  },
  chartContainer: {
    marginLeft: -22,
  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  subTitle: {
    display: 'block',
    textAlign: 'right'
  },
  
});

class Dashboard extends React.Component {
  state = {
    open: false
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  handleColorChange = () => {
    //console.log('DASHBOARD COLOR CHANGE')
    this.setState({
      ...this.state,
        options:{
          colors: {
            headerBgColor: sessionStorage.getItem('headerBgColor'),
            headerColor: sessionStorage.getItem('headerColor'),
            buttonBgColor: sessionStorage.getItem('buttonBgColor'),
            buttonColor: sessionStorage.getItem('buttonColor'),
            menuLeftBgColor: sessionStorage.getItem('menuLeftBgColor'),
            menuLeftColor: sessionStorage.getItem('menuLeftColor'),
          }
        }
       
    })
  }
  handleLogoChange = () => {
   // console.log('DASHBOARD HANDLE LOGO CHANGE')
       this.getOptions()
  }
  getOptions = (companyId) => {
    
    const db = fbConfig.firestore();
    if(companyId){
      db
      .collection(companyId)
      .doc("companyOptions")
      .get()
      .then((querySnapshot) => {
            //console.log(querySnapshot.data()); 
            var data =  querySnapshot.data()
            this.setState({
              options: data
            })
            sessionStorage.setItem('options', JSON.stringify(data))
            sessionStorage.setItem('account', data.account)
            sessionStorage.setItem('buttonBgColor', data.colors.buttonBgColor)
            sessionStorage.setItem('buttonColor', data.colors.buttonColor)
            sessionStorage.setItem('headerBgColor', data.colors.headerBgColor)
            sessionStorage.setItem('headerColor', data.colors.headerColor)
            sessionStorage.setItem('menuLeftBgColor', data.colors.menuLeftBgColor)
            sessionStorage.setItem('menuLeftColor', data.colors.menuLeftColor)
            sessionStorage.setItem('companyLogoName', data.logo.companyLogoName)
            sessionStorage.setItem('companyLogoUrl', data.logo.companyLogoUrl)
      })
      
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {

    //this.getOptions(this.props.profile.companyId)
    //console.log('NEXT PROPS',   nextProps)
    if(nextProps.profile.companyId){
      this.getOptions(nextProps.profile.companyId)
      sessionStorage.setItem('companyId', nextProps.profile.companyId)
      

    } 
  }
  componentDidMount(){
    if(this.props.profile.companyId){
      this.getOptions(this.props.profile.companyId)
    }
  }

  render() {
    //console.log('dash', this.props)
    const { auth, classes  } = this.props;
    if(!auth.uid ) return <Redirect to='/login' />
    var translateMenu =  'translate(-100%)'
    if(this.state.options && this.state.options.colors) { // or !this.props.user.profile depending on your initialState
        const {headerBgColor, headerColor, menuLeftBgColor, menuLeftColor } = this.state.options.colors
        var appBarBg = headerBgColor || '#FFFFFF'
        var appBarLink = headerColor || '#666666'
        var appMenuLeftColor = menuLeftColor || '#69b4a7'
        var appMenuLeftBgColor = menuLeftBgColor || '#FFFFFF'
        translateMenu =  'translate(-0%)'
     }
     
      const  { profile } = this.props
     
       var logoUrl = sessionStorage.getItem("companyLogoUrl") || ''
       var logoName = sessionStorage.getItem("companyLogoName") || ''
  
    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          style={{background: appBarBg }}
          className={classNames(classes.appBar, this.state.open && classes.appBarShift)}
        >
          <Toolbar disableGutters={!this.state.open} className={classes.toolbar}>
           
            <IconButton
              style={{color: appBarLink }}
              aria-label="Open drawer"
              onClick={this.handleDrawerOpen}
              className={classNames(
                classes.menuButton,
                this.state.open && classes.menuButtonHidden,
              )}
            >
              <MenuIcon />
            </IconButton>
            { logoName === '' && logoUrl === '' ? '' :  
              <Avatar 
                  alt={logoName}
                  src={ logoUrl } 
                  className={classNames(
                  classes.menuLogo,
                  this.state.open && classes.menuLogoHidden,
                )}
              />
             }
            <Typography
              component="h1"
              variant="h6"
              style={{color: appBarLink }}
              noWrap
              className={classes.title}
            >
            {this.props.profile.company} 
            </Typography>
           
             <MenuTop appBarLink={appBarLink} />

          </Toolbar>
        </AppBar>
        <Drawer 
          
          variant="permanent"
          classes={{
            paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
          }}
          open={this.state.open}
          style={ {background: appMenuLeftBgColor, transform: translateMenu, transition: 'all .32s ease-in-out' } }
          className="menu-left"
        > 
      
          <div className={classes.toolbarIcon}>
            { logoName === '' && logoUrl === '' ? '' :  
            <Avatar 
                  alt={logoName}
                  src={ logoUrl } 
                  className={classNames(
                  classes.menuLogo,
                  !this.state.open && classes.menuLogoHidden,
                )}
              />
             }
          <Typography
             
              variant="h6"
              color="inherit"
              className={classes.title}
              style={ {color: appMenuLeftColor } }
            >
              Menu
            </Typography>
         
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon style={ {color: appMenuLeftColor  } } />
            </IconButton>
          </div>
          <Divider style={ {background: appMenuLeftColor } }/>
          <List ><MenuLeft user={this.props.profile} menuLeftBgColor={appMenuLeftBgColor } menuLeftColor={appMenuLeftColor} /></List>
          <Divider style={ {background: appMenuLeftColor } }/>
         
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Switch>
            <Route path='/dashboard' component={ MainDashContent } />
            <Route path='/allclients'  component={ AllClients } />
            <Route
              path='/trainers'
              render={(props) => <Trainers {...props} companyId={profile.id} />}
            />
            <Route
              path='/account'
              render={(props) => <UserProfile {...props} handleColorChange={this.handleColorChange} handleLogoChange={this.handleLogoChange} profile={this.props.profile}/>}
            />
            <Route path='/test' profile={this.props.profile.company} component={ Test } />
            {/* <Route path='/account' component={ UserProfile } /> */}
            <Route path='/scheduler'  component={ Scheduler } />
            <Route path='/workout'  component={ Workout } />
            <Route path='/nutrition'  component={ Nutrition } />
            <Route path='/trainerprofile'  component={ TrainerProfilePage} />
            <Route path='/notifications'  component={ Notifications } />
          </Switch>
  
        </main>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state)=> {
 // console.log("STATE",state)
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    //options: state.firebase.options,
    //logo: state.firebase.profile.logo
  };
};
export default compose(
  withStyles(styles),
  connect( mapStateToProps, null)
)(Dashboard);